<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="500" v-if="dialog">
			<v-card>
				<v-card-title class="headline" v-if="propAdd=='tambah'">Tambah Pengguna</v-card-title>
				<v-card-title class="headline" v-else>Edit Pengguna</v-card-title>
				<v-card-text class="pb-2">
					<v-row>
						<v-form ref="formUser" role="form">
							<v-col cols="12" sm="12" md="12" class="py-0">
								<v-row>
									<v-col cols="12" class="text-center">
										<v-hover v-slot:default="{ hover }">
											<v-avatar color="grey" size="100">
												<img class="avatar" :src="params.image ? params.image : '/assets/user/profile-pict-menolak-big.png'">
												<v-expand-transition v-if="propAdd=='tambah'">
													<div v-if="hover" class="d-flex transition-fast-in-fast-out cyan darken-2 v-card--reveal white--text" style="height: 100%;">
														<v-file-input dark color="white" prepend-icon="mdi-camera" hide-input hide-details class="icon-upload-avatar">
														</v-file-input>
													</div>
												</v-expand-transition>
											</v-avatar>
										</v-hover>
									</v-col>
									<v-col cols="12" sm="6" md="6" v-if="propAdd=='tambah'" class="pb-0">
										<v-text-field validate-on-blur outlined dense  @focus="() => responseError.username=''" :error-messages="responseError.username"  v-model="params.username" label="Username" color="cyan darken-2" hint="Username minimal 6 karakter" :rules="[inputrules.required]"></v-text-field>
									</v-col>
									<v-col cols="12" sm="6" md="6" class="pb-0">
										<v-text-field validate-on-blur outlined dense  @focus="() => responseError.name=''" :error-messages="responseError.name" v-model="params.name" label="Nama" color="cyan darken-2" :rules="[inputrules.required]"></v-text-field>
									</v-col>
									<v-col cols="12" md="6" class="pb-0" v-if="false">
										<v-autocomplete class="text-capitalize" validate-on-blur outlined dense @focus="() => responseError.type=''" :error-messages="responseError.type" v-model="params.type" :items="OptionType" item-text="type_name" item-value="type_name" label="Tipe Akun" color="cyan darken-2" item-color="cyan darken-2" no-data-text="Tidak ada data yang sesuai">
											<template v-slot:item="{item}">
												<div class="text-capitalize">{{item.type_name}}</div>
											</template>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" v-if="propAdd=='tambah'" sm="6" md="6" class="pb-0">
										<v-text-field validate-on-blur outlined dense  @focus="() => responseError.password=''" :error-messages="responseError.password" v-model="params.password" label="Kata Sandi" type="password" color="cyan darken-2" hint="Kata Sandi minimal 6 karakter" :rules="[inputrules.required, inputrules.password]"></v-text-field>
									</v-col>

									<v-col cols="12" v-if="propAdd=='tambah'" sm="6" md="6" class="pb-0">
										<v-text-field validate-on-blur outlined dense  @focus="() => responseError.repassword=''" :error-messages="responseError.repassword" v-model="params.repassword" label="Ulangi Kata Sandi" type="password" color="cyan darken-2" :rules="[repasswordRules]"></v-text-field>
									</v-col>
									<v-col cols="12" sm="6" md="6" class="pb-0">
										<v-text-field validate-on-blur outlined dense  @focus="() => responseError.email=''" :error-messages="responseError.email" v-model="params.email" label="Email" color="cyan darken-2" :rules="[inputrules.required]"></v-text-field>
									</v-col>
									<v-col cols="12" sm="6" md="6" class="pb-0">
										<v-text-field validate-on-blur outlined dense @keypress="onlyNumber"  @focus="() => responseError.mobilephone=''" :error-messages="responseError.mobilephone" v-model="params.mobilephone" label="No Handphone" color="cyan darken-2" :rules="[inputrules.required]"></v-text-field>
									</v-col>
								</v-row>
							</v-col>
						</v-form>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hide()">Batal</v-btn>
					<v-btn dark color="cyan darken-2" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-snackbar v-model="snackbar" :timeout="timeout" right top :color="snackbarClass">
			{{ text }}
			<template v-slot:action="{ attrs }">
				<v-btn color="white" text v-bind="attrs" @click="snackbar = false">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</template>
		</v-snackbar>
	</v-row>
</template>

<script>
import {mapState} from 'vuex'
export default {
	data () {
		return {
			dialog: false,
			snackbarClass : "green accent-4",
			snackbar: false,
			text : "",
			timeout: 2000,
			repasswordRules: value => value == this.params.password || 'Password tidak cocok',
			params: {
				username: '',
				password: '',
				repassword: '',
				name : '',
				email : '',
				mobilephone : '',
			},
		}
	},
	props: {
		propAdd: String,
		edit: String,
		val: Object,
		filter: Object,
	},
	computed: {
		...mapState('userSupplier', ['responseError', 'OptionType']),
	},
	methods: {

		show(data) {
			this.dialog = true
			Object.assign( this.params , data)
		},
		hide() {
			this.dialog = false
		},
		simpan() {
			if (this.$refs.formUser.validate()) {
				this.$emit('action', this.params)
			}
		},
		reset () {
			this.params.username = ''
			this.params.password = ''
			this.params.repassword = ''
			this.params.name  = ''
			this.params.email  = ''
			this.params.mobilephone  = ''
			this.params.warehouse_id  = ''
			this.params.type  = ''
		}
	},
	watch: {
		val () {
			if (Object.keys(this.val).length > 0) {
				this.params.id = this.val.user_supplier_id
				this.params.name  = this.val.user_supplier_name
				this.params.email  = this.val.user_supplier_email
				this.params.mobilephone  = this.val.user_supplier_mobilephone
				this.params.type  = this.val.user_supplier_type
			} else {
				this.reset()
			}
		}
	},
	created() {
	}
}
</script>